import { CSSProperties } from "react";
import { WaterUserStatus } from "../enums/global.enums";
import { Tag } from "antd";

export function contractStatusPipe(value: string) {
    switch (value) {
        case WaterUserStatus.All: return "Tất cả";
        case WaterUserStatus.Processing: return "Đang đăng ký";
        case WaterUserStatus.Active: return "Đang sử dụng";
        case WaterUserStatus.TempDisabled: return "Tạm dừng cấp nước";
        case WaterUserStatus.Disabled: return "Ngừng sử dụng";
    }
    return "";
}

export function contractStatusTagsPipe(value?: string, style?: CSSProperties) {
    switch (value) {
        case WaterUserStatus.All: return <Tag color="default" style={style}>Tất cả</Tag>;
        case WaterUserStatus.Processing: return <Tag color="var(--primary-button)" style={style}>Đang đăng ký</Tag>;
        case WaterUserStatus.Active: return <Tag color="var(--success-button)" style={style}>Đang sử dụng</Tag>;
        case WaterUserStatus.TempDisabled: return <Tag color="var(--danger-button)" style={style}>Tạm dừng cấp nước</Tag>;
        case WaterUserStatus.Disabled: return <Tag color="var(--disabled-button)" style={style}>Ngừng sử dụng</Tag>;
    }
    return <Tag color="default" style={style}>Chưa cập nhật</Tag>;
}